import { useState, type CSSProperties } from "react";
import { DISCORD_INVITE_URL } from "@/const";

type DiscordIconProps = {
  size?: number;
  className?: string;
  style?: CSSProperties;
};

export function DiscordIcon({ size = 18, className, style }: DiscordIconProps) {
  return (
    <svg
      className={className}
      style={style}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
    </svg>
  );
}

type DiscordButtonProps = {
  compact?: boolean;
  className?: string;
  style?: CSSProperties;
  label?: string;
};

export default function DiscordButton({
  compact = false,
  className,
  style,
  label = "Discord",
}: DiscordButtonProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={DISCORD_INVITE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Join Discord"
      className={className}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onFocus={() => setIsHovered(true)}
      onBlur={() => setIsHovered(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: compact ? 0 : 8,
        width: compact ? 32 : undefined,
        height: compact ? 32 : 34,
        padding: compact ? 0 : "0 14px",
        borderRadius: 8,
        border: "none",
        background: isHovered
          ? "rgba(88,101,242,0.30)"
          : "rgba(88,101,242,0.16)",
        color: isHovered ? "#c7ccff" : "#a8b1ff",
        cursor: "pointer",
        fontFamily: "inherit",
        fontSize: 13,
        fontWeight: 600,
        lineHeight: 1,
        textDecoration: "none",
        whiteSpace: "nowrap",
        transition: "background .15s ease",
        ...style,
      }}
    >
      <DiscordIcon size={compact ? 17 : 18} style={{ flexShrink: 0 }} />
      {!compact && <span>{label}</span>}
    </a>
  );
}
